export default __webpack_public_path__ + "static/media/security.2f9349a1.svg";